import styled from 'styled-components'

export const SelectContainer = styled.div`
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 0;
  margin-right: 0;
`
